"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onNotificationEvent = exports.notificationCallback = void 0;
let globalNotificationCallback = null;
/**
 * This is used internally to handle notification events sent from the native
 * side.
 */
const notificationCallback = (...args) => globalNotificationCallback?.(...args);
exports.notificationCallback = notificationCallback;
/** Sets a handler for notification events. */
const onNotificationEvent = (callback) => {
    globalNotificationCallback = callback;
};
exports.onNotificationEvent = onNotificationEvent;
//# sourceMappingURL=notification-callback.js.map